import React from 'react';
import { SelectableItemProps } from '../selectable-item/SelectableItem';

export interface AsyncSuggestionListContextValue {
  searchTerm?: string,
  items: SelectableItemProps[],
  onInputChange: (searchTerm: string) => void,
  onItemSelect: (item: SelectableItemProps) => void,
  error?: Error,
  minFilteringCharacters?: number,
}

export default React.createContext<AsyncSuggestionListContextValue>({
  items: [],
  onItemSelect: () => {},
  onInputChange: () => {},
  error: undefined,
  minFilteringCharacters: 2,
});
